import React from 'react';
import * as styles from './styles.scss';

const Select = ({
    id,
    name,
    className,
    label,
    children,
    ...props
}) => (
    <>
        {
            label &&
            <label htmlFor={id || name} className={styles.label}>
                {label}
            </label>
        }
        <select
            className={styles.select || className}
            name={name}
            {...props}
        >
            {children}
        </select>
    </>
);

const Option = ({ ...props }) => (
    <option { ...props } />
);

export default Select;
export { Option };
